import Vue from 'vue'
import AppUtils from '@/utils/AppUtils'

function commentNode (el, vnode) {
  const comment = document.createComment(' ')
  Object.defineProperty(comment, 'setAttribute', {
    value: () => undefined
  })
  vnode.elm = comment
  vnode.text = ' '
  vnode.isComment = true
  vnode.context = undefined
  vnode.tag = undefined
  vnode.data.directives = undefined

  if (vnode.componentInstance) {
    vnode.componentInstance.$el = comment
  }

  if (el.parentNode) {
    el.parentNode.replaceChild(comment, el)
  }
}

Vue.directive('debug', {
  bind (el, binding, vnode) {
    if (!AppUtils.isDebugMode() || (!binding.value && binding.value !== undefined)) {
      commentNode(el, vnode)
      return
    }
    el.style.padding = '12px'
    el.style.backgroundColor = '#00f2'
    el.style.border = '1px solid #00f9'
    el.style.borderRadius = '5px'
    el.setAttribute('title', '`v-debug`| This is a debug element, will be hidden in production mode')
  }
})

Vue.directive('readonlysection', {
  update (el, binding, vnode) {
    if (binding.value === false) {
      el.classList.remove('readOnlySection')
      el.onclick = null
      return
    }

    el.classList.add('readOnlySection')
    el.onclick = () => {
      let title = 'This section is read only'
      const callback1 = (title) => { alert(title) }

      // check element attribute
      if (el.getAttribute('readonlysection-title')) {
        title = el.getAttribute('readonlysection-title')
      }
      // ? cannot use attribute to pass function
      // if (el.getAttribute('readonlysection-callback')) {
      //   callback1 = el.getAttribute('readonlysection-callback')
      // }

      callback1(title)
    }
  }
})

Vue.directive('auth', {
  bind (el, binding, vnode) {
    if (!AppUtils.isLoggedIn() && (binding.value === undefined || binding.value === true)) commentNode(el, vnode)
    if (AppUtils.isLoggedIn() && binding.value === false) commentNode(el, vnode)
  }
})

Vue.directive('roles', {
  bind (el, binding, vnode) {
    if (!AppUtils.allowAccess(false, binding.value)) commentNode(el, vnode)
  }
})

Vue.directive('permissions', {
  bind (el, binding, vnode) {
    if (!AppUtils.allowAccess(false, [], binding.value)) commentNode(el, vnode)
  }
})

// -- Becky Specific -- //

Vue.directive('phase2', {
  bind (el, binding, vnode) {
    if (!process.env.PHASE2) commentNode(el, vnode)
  }
})
